import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import { Button } from 'components/landing/components';

const dumbServices = dumbBem('l-services');
const ContentFooter = tx([{ element: 'content-footer' }, dumbServices])('div');

const TalkButton = ({ scrollToDemoForm }) => {
  return (
    <ContentFooter>
      <Button
        onClick={() => scrollToDemoForm()}
        modifier="reversed-colors"
        data-testid="button"
      >
        LET&apos;S TALK
      </Button>
    </ContentFooter>
  );
};

TalkButton.propTypes = {
  scrollToDemoForm: PropTypes.func.isRequired,
};

export default TalkButton;



// WEBPACK FOOTER //
// ./src/components/landing/pages/services/TalkButton.jsx